const apiCallHandler = (call) => {
  return call()
    .then((response) => ({ response }))
    .catch((error) => ({ error }))
}

export default apiCallHandler
